const mailActions = {
  FILTER_ATTRIBUTE: 'FILTER_ATTRIBUTE',
  filterAction: newFilterAttr => {
    return (dispatch, getState) => {
      const filterAttr = getState().Mails.get('filterAttr');
      if (newFilterAttr) {
        if (newFilterAttr.bucket) {
          filterAttr.bucket = newFilterAttr.bucket;
          filterAttr.tag = newFilterAttr.tag;
        } else if (newFilterAttr.tag) {
          filterAttr.tag = newFilterAttr.tag;
        }
      }
      dispatch({
        type: mailActions.FILTER_ATTRIBUTE,
        filterAttr
      });
      let payload = {
        page: "1",
        category: "",
        archive: false
      };
      if (["Issues"].includes(filterAttr.bucket)) {
        payload.category = "/category-issue";
        payload.action = "DO_GET_MAIL";
      }
      if (["Enquiries"].includes(filterAttr.bucket)) {
        payload.category = "/category-propertyEnquiry";
        payload.action = "DO_GET_MAIL";
      }
      if (["Inbox", "Archive"].includes(filterAttr.bucket)) {
        payload.category = "";
        payload.action = "DO_GET_MAIL";
      }
      if (["Archive"].includes(filterAttr.bucket)) {
        payload.archive = true;
        payload.category = "";
        payload.action = "DO_GET_MAIL";
      }
      if (["Sent"].includes(filterAttr.bucket)) {
        payload.category = "";
        payload.action = "DO_GET_SENT_MAIL";
      }
      dispatch({
        type: mailActions[payload.action],
        payload
      });
    };
  },
  SELECTED_MAIL: 'SELECTED_MAIL',
  selectMail: selectedMail => {
    return (dispatch, getState) => {
      const allMails = getState().Mails.get('mailByThread');
      dispatch({
        type: mailActions.SELECTED_MAIL,
        selectedMail,
        allMails
      });
    };
  },
  SELECTED_MAIL_FROM_URL: 'SELECTED_MAIL_FROM_URL',
  selectMailFromUrl: selectedMail => {
    return (dispatch, getState) => {
      const allMails = getState().Mails.get('mailByThread');
      dispatch({
        type: mailActions.SELECTED_MAIL,
        selectedMail,
        allMails
      });
    };
  },
  COMPOSE_MAIL: 'COMPOSE_MAIL',
  changeComposeMail: composeMail => ({
    type: mailActions.COMPOSE_MAIL,
    composeMail
  }),
  REPLY_MAIL: 'REPLY_MAIL',
  changeReplyMail: replyMail => ({
    type: mailActions.REPLY_MAIL,
    replyMail
  }),
  SEARCH_STRING: 'SEARCH_STRING',
  changeSearchString: searchString => ({
    type: mailActions.SEARCH_STRING,
    searchString
  }),
  UPDATE_CHECKED_MAIL: 'UPDATE_CHECKED_MAIL',
  updateCheckedMail: checkedMails => ({
    type: mailActions.UPDATE_CHECKED_MAIL,
    checkedMails
  }),
  BULK_ACTIONS: 'BULK_ACTIONS',
  bulkActions: payload => ({
    type: mailActions.BULK_ACTIONS,
    payload
  }),
  TOGGLE_ADDRESS: 'TOGGLE_ADDRESS',
  toggleAddress: () => ({
    type: mailActions.TOGGLE_ADDRESS
  }),
  TOGGLE_DRAWER: 'TOGGLE_DRAWER',
  toggleOpenDrawer: openDrawer => ({
    type: mailActions.TOGGLE_DRAWER,
    openDrawer
  }),
  TOGGLE_SEARCH: 'TOGGLE_SEARCH',
  toggleSearch: () => ({ type: mailActions.TOGGLE_SEARCH }),
  DO_GET_MAIL: 'DO_GET_MAIL',
  doGetMail: payload => ({
    type: mailActions.DO_GET_MAIL,
    payload
  }),
  DO_GET_SENT_MAIL: 'DO_GET_SENT_MAIL',
  doGetSentMail: payload => ({
    type: mailActions.DO_GET_SENT_MAIL,
    payload
  }),
  DO_GET_SENT_MAIL_SUCCEEDED: 'DO_GET_SENT_MAIL_SUCCEEDED',
  doGetSentMailSucceeded: payload => ({
    type: mailActions.DO_GET_SENT_MAIL_SUCCEEDED,
    payload
  }),
  DO_GET_MAIL_SUCCEEDED: 'DO_GET_MAIL_SUCCEEDED',
  doGetMailSucceeded: payload => ({
    type: mailActions.DO_GET_MAIL_SUCCEEDED,
    payload
  }),
  DO_REPLY_TO_THREAD: 'DO_REPLY_TO_THREAD',
  doReplyToThread: payload => ({
    type: mailActions.DO_REPLY_TO_THREAD,
    payload
  }),
  DO_REPLY_TO_THREAD_SUCCEEDED: 'DO_REPLY_TO_THREAD_SUCCEEDED',
  doReplyToThreadSucceeded: payload => ({
    type: mailActions.DO_REPLY_TO_THREAD_SUCCEEDED,
    payload
  }),
  DO_START_THREAD: 'DO_START_THREAD',
  doStartThread: payload => ({
    type: mailActions.DO_START_THREAD,
    payload
  }),
  DO_ARCHIVE_THREAD: 'DO_ARCHIVE_THREAD',
  doArchiveThread: payload => ({
    type: mailActions.DO_ARCHIVE_THREAD,
    payload
  }),
  DO_UNARCHIVE_THREAD: 'DO_UNARCHIVE_THREAD',
  doUnArchiveThread: payload => ({
    type: mailActions.DO_UNARCHIVE_THREAD,
    payload
  }),
  DO_MARK_THREAD_READ: 'DO_MARK_THREAD_READ',
  doMarkThreadRead: payload => ({
    type: mailActions.DO_MARK_THREAD_READ,
    payload
  }),
  DO_GET_BUCKET_COUNTS: 'DO_GET_BUCKET_COUNTS',
  doGetBucketCounts: () => ({
    type: mailActions.DO_GET_BUCKET_COUNTS,
  }),
  DO_GET_BUCKET_COUNTS_SUCCEEDED: 'DO_GET_BUCKET_COUNTS_SUCCEEDED',
  doGetBucketCountsSucceeded: payload => ({
    type: mailActions.DO_GET_BUCKET_COUNTS_SUCCEEDED,
    payload
  }),
};
export default mailActions;



// WEBPACK FOOTER //
// ./src/redux/mail/actions.js